import React, {useMemo} from "react";
import '../../../i18/config';
import {useTranslation} from "react-i18next";
import {SalePlanParamValueType} from "../../../redux/Sale/Plan/types";
import {Progress} from "reactstrap";
import {formatBytes} from "../../../helpers/functions";
import {LicenseProductParam} from "../../../redux/Sale/License/types";

interface ItemProps {
    item: SalePlanParamValueType;
}
const ListItem = ({ item }: ItemProps) => {

    const { t } = useTranslation(['plan']);

    const { progressBarTemplate, displayPercent } = useMemo(() => {
        let template = 'bg-success';
        let percent = item.percent;

        if (percent !== undefined) {
            if (percent > 100) {
                percent = 100;
            }
            if (percent > 80) {
                template = 'bg-danger';
            } else if (percent > 60) {
                template = 'bg-warning';
            }
        }
        return { progressBarTemplate: template, displayPercent: percent };
    }, [item.percent]);

    const FormatValue = (value:number) =>
        new Intl.NumberFormat('en-US', {
            style: 'decimal',
            notation: 'compact',
        }).format(value);

    return (
        <div className="text-reset notification-item d-block dropdown-item position-relative">
            <div className="d-flex">
                <div className="flex-1">
                    <a href={(item.isPromo === true)? undefined:"#"} target="_blank" rel="noreferrer">
                        <h6 className="mt-0 mb-2 lh-base">
                            {t('plan:'+item.productParam.code)}
                        </h6>
                    </a>
                </div>
                {displayPercent !== undefined &&
                <div className="px-2 fs-15">
                    {item.count !== undefined &&
                    <span className="mb-0 fs-12 text-muted">{
                        item.productParam.code === LicenseProductParam.MAIN_STORAGE ?
                            formatBytes(item.count)
                            :
                            FormatValue(item.count)
                        } / </span>
                    }
                    {item.limit !== undefined &&
                    <span className="mb-0 fs-12 text-muted">{
                        item.productParam.code === LicenseProductParam.MAIN_STORAGE ?
                            formatBytes(item.limit)
                            :
                            FormatValue(item.limit)}</span>
                    }
                    <span className={"badge ms-2 "+progressBarTemplate}>{displayPercent}%</span>
                </div>
                }
                {item.isPromo === true &&
                    <div className="px-2 fs-15 mb-2">
                        <a href="#" type="button" target="_blank"
                           rel="noreferrer"
                           className="btn btn-success btn-sm">{t('plan:activate')}</a>
                    </div>
                }
            </div>

            {displayPercent !== undefined &&
                <Progress
                    className={"d-flex flex-grow-1 flex-row w-100 "}
                    value={Math.ceil(displayPercent)}
                    barClassName={progressBarTemplate}
                    striped={false}
                    animated={true}
                />
            }

        </div>
    );
};

export default ListItem;
